import wixData from 'wix-data';
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

function open_Lightbox(){
  let query = wixLocation.query;
  var goto = query.name;
  wixWindow.openLightbox(goto);
}

$w.onReady(function () {
  open_Lightbox();
});